export const getApprovalApplyFailedNotificationMessage = () => 'Failed to apply changes. Try again later.';
